import { Plus, PricingIcon, RowCards, RowCardWithoutActionProps, SoftButton } from '@weareopenr/component-library';
import { DashboardWidget } from './DashboardWidget';
import { usePriceSchemes } from 'src/hooks/usePriceSchemes';
import { StatusChip } from 'src/components/StatusChip/StatusChip';
import { PublicationStatus } from 'src/types/price.types';
import { Routes } from 'src/routes';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';

export const PriceSchemesWidget = () => {
  const navigate = useNavigate();
  const { data: priceSchemes = [], isLoading } = usePriceSchemes();
  const { liveCount, scheduledCount } = useMemo(
    () =>
      priceSchemes.reduce(
        (counts, scheme) => {
          if (scheme.publicationStatus === PublicationStatus.IN_USE) counts.liveCount += 1;
          else if (scheme.publicationStatus === PublicationStatus.SCHEDULED) counts.scheduledCount += 1;
          return counts;
        },
        { liveCount: 0, scheduledCount: 0 },
      ),
    [priceSchemes],
  );

  const priceSchemeRows: RowCardWithoutActionProps[] = useMemo(
    () =>
      [...priceSchemes]
        .sort((a, b) => b.modificationDateTime.diff(a.modificationDateTime))
        .slice(0, 3)
        .map((scheme) => {
          const chip =
            scheme.publicationStatus === PublicationStatus.IN_USE ? (
              <StatusChip entity="price-scheme" status={scheme.publicationStatus} />
            ) : null;
          return {
            id: scheme.id,
            leading: <PricingIcon size="small" />,
            title: scheme.name,
            meta: [
              {
                label: `last updated ${scheme.modificationDateTime.format('DD/MM/YY HH:mm:ss')}`,
                colour: 'liquorice',
                key: 'status',
              },
            ],
            chip,
            action: {
              label: 'View Price Scheme',
              to: `/price-schemes/${scheme.id}`,
            },
          };
        }),
    [priceSchemes],
  );

  return (
    <DashboardWidget
      title="Price Schemes"
      emptyCta={
        <SoftButton size="full-width" icon={Plus} onClick={() => navigate(Routes.PRICE_SCHEMES)}>
          Create a price scheme
        </SoftButton>
      }
      link={{ label: 'View All', to: Routes.PRICE_SCHEMES }}
      isEmpty={priceSchemes.length === 0}
      isLoading={isLoading}
      Kpis={[
        {
          id: 'live-price-scheme-status',
          size: 'small',
          value: liveCount,
          label: 'Live',
          testId: 'kpi-live-price-scheme-status',
        },
        {
          id: 'scheduled-price-scheme-status',
          size: 'small',
          value: scheduledCount,
          label: 'Scheduled',
          testId: 'kpi-scheduled-price-scheme-status',
        },
      ]}
    >
      <RowCards rows={priceSchemeRows} />
    </DashboardWidget>
  );
};
